import { message } from 'antd';
import { apiHolder, apis, getIn18Text } from 'api';
const edmApi = apiHolder.api.requireLogicalApi(apis.edmSendBoxApiImpl);
export const getTaskContent = async (edmEmailId) => {
    if (edmEmailId === '') {
        return message.error(getIn18Text('edmEmai'));
    }
    const { contentEditInfo } = await edmApi.copyFromSendBox({ edmEmailId });
    const content = contentEditInfo.emailContent;
    return content;
};
